import Dialog from '@mui/material/Dialog';
import {
  Box,
  Button,
  DialogContent,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './save-search-modal.scss';
import { useState } from 'react';

interface SaveSearchModalProps {
  isOpen: boolean;
  close: () => void;
  isPending: boolean;
  addSavedSearch: (val: string) => void;
}

export const SaveSearchModal = ({
  isOpen,
  close,
  addSavedSearch,
  isPending,
}: SaveSearchModalProps) => {
  const [searchName, setSearchName] = useState('');

  return (
    <>
      {isOpen ? (
        <Dialog
          data-testid="save-search-component"
          className="save-search-component"
          open={isOpen}
          onClose={close}
          aria-labelledby="auth-dialog-title"
        >
          <Box className="container">
            <Button
              className="close-btn"
              onClick={close}
              sx={{ color: 'white' }}
              variant="transparent"
            >
              <CloseIcon sx={{ fill: '#49454F' }} />
            </Button>
            <DialogContent className="content">
              <Typography variant="h5" className="search-filters-title">
                Save Search
              </Typography>
              <Typography className="search-filters-text">
                The search will be saved and added to your portal. You can name
                your search below:{' '}
              </Typography>
              <TextField
                onChange={(e) => setSearchName(e.target.value)}
                sx={{ marginTop: '20px' }}
                className="text-input"
                label="Search Name"
                variant="outlined"
              />
              <Button
                disabled={searchName.length === 0 || isPending}
                className="save-btn"
                onClick={() => addSavedSearch(searchName)}
                variant="contained"
              >
                {isPending ? 'Saving...' : 'Save'}
              </Button>
            </DialogContent>
          </Box>
        </Dialog>
      ) : null}
    </>
  );
};
